export default "/images/vendor/flag-icons/flags/1x1/ki.svg?f832c557a2dc399cfdbc628e26ed3f42";